/*
    创建者：shuxiaokai
    创建时间：2019-12-04 14:59
    模块名称：核心画布
    备注：所有绘制内容均在画布内部
*/
<template>
    <div ref="screen" class="f-screen">
        {{ widgets }}
        <hr />
        {{ widgetRect }}
        <div v-for="(item, index) in widgets" :key="index">
            <s-card-widget v-show="item.type === 'card'" :id="item.id" @click.native.stop="handleSelectWidget(item)"></s-card-widget>
            <s-sample-num-widget v-show="item.type === 'sampleBatch'" :id="item.id" @click.native.stop="handleSelectWidget(item)"></s-sample-num-widget>
            <s-sample-enterprise-widget v-show="item.type === 'sampleEnterprise'" :id="item.id" @click.native.stop="handleSelectWidget(item)"></s-sample-enterprise-widget>
        </div>
    </div>
</template>

<script>
import cardWidget from "@/pages/model/f/widgets/card-widget"
import sampleNumWidget from "@/pages/model/f/widgets/sample-num"
import sampleEnterpriseWidget from "@/pages/model/f/widgets/sample-enterprise"
export default {
    components: {
        "s-card-widget": cardWidget,
        "s-sample-num-widget": sampleNumWidget,
        "s-sample-enterprise-widget": sampleEnterpriseWidget,
    },
    data() {
        return {
            wrapInfo: { //包裹框位置信息
                width: 0,
                height: 0,
                left: 0,
                top: 0,
            },
            dropInfo: { //拖拽框位置信息
                width: 0,
                height: 0,
                left: 0,
                top: 0, 
            },
            showContextMenu: false, //是否展示contextmenu
        };
    },
    computed: {
        widgetRect() {
            return this.$store.state.widget.widgetConf
        },
        widgets() {
            return this.$store.state.widget.widgetList
        },
        wrapRect() {
            return this.$store.state.widget.wrapConfig.boundingClientRect;
        },
        selectWidgetId() {
            return this.$store.state.widget.selectWidgetId;
        }
    },
    mounted() {
        this.init(); //初始化
    },
    methods: {
        //=====================================初始化====================================//
        init() {
            const wrapRect = this.$refs["screen"].getBoundingClientRect();
            this.$refs["screen"].addEventListener("mouseup", (e) => { //点击空白区域清除选中状态
                e.stopPropagation();
                this.$store.commit("changeWidgetActiveState", "widget");
                this.$store.commit("changeSelectWidgetId", null); 
            })
            this.$store.commit("changeWrapBoundingClientRect", {
                left: wrapRect.left,
                top: wrapRect.top,
                width: wrapRect.width,
                height: wrapRect.height,
            });
        },
        //选中组件
        handleSelectWidget(item) {
            this.$store.commit("changeSelectWidgetId", item.id);
            this.$store.commit("changeWidgetActiveState", "config"); //选择组件则自动切换至配置选项
        },
        

      
    }
};
</script>



<style lang="scss">
    .f-screen {
        width: 90%;
        height: 100%;
        overflow: auto;
        background: $gray-400;
        position: relative;
        margin-left: 30px;
    }

</style>
